import React, { useState } from 'react';
import './../styles.css';
import { Link, useParams, useNavigate } from 'react-router-dom';


const ResetPassword = () => {

  const { userId, token } = useParams();
  const url = `${process.env.REACT_APP_SRV_BASE_URL}/api/passreset/reset`;
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const req = { 
      userId: userId,
      token: token,
      password: password
    };
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(req)
    })
      .then(res => res.text())
      .then(msg => console.log(`${url}: ${msg}`))
      .then(() => navigate('/'))
      .catch(err => console.log(`${url} fetch error: ${err}`))
  };

  return (
    <div className="reset-password-container">
      <h2 className="reset-password-title">Reset Password</h2>
      <p className="reset-password-text">Enter your new password below.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            placeholder="Enter new password"
            value={password}
            onChange={handlePasswordChange}
            required
          />
        </div>
        <button type="submit" className="btn reset-password-btn">Reset Password</button>
      </form>
      <div className="reset-password-login-link">
          <span className='center mt-1'><Link to="/" className="login-page">Login Page</Link></span>
      </div>
    </div>

  );
};

export default ResetPassword;
